import React from 'react';
import { Box, Flex, IconButton, Tooltip } from 'pounceV2';

interface ResponseNavigationControlProps {
  onNavigatePrevious: () => void;
  onNavigateNext: () => void;
  showPrevious: boolean;
  showNext: boolean;
}

const ResponseNavigationControlV3: React.FC<ResponseNavigationControlProps> = ({
  onNavigatePrevious,
  onNavigateNext,
  showPrevious,
  showNext,
}) => {
  if (!showPrevious && !showNext) {
    return null;
  }

  return (
    <Flex spacing={1} align="center">
      <Tooltip content="Previous response" placement="bottom">
        <Box as="span">
          <IconButton
            icon="chevron-left"
            aria-label="Navigate to previous response"
            variant="ghost"
            size="medium"
            disabled={!showPrevious}
            onClick={onNavigatePrevious}
          />
        </Box>
      </Tooltip>
      <Tooltip content="Next response" placement="bottom">
        <Box as="span">
          <IconButton
            icon="chevron-right"
            aria-label="Navigate to next response"
            variant="ghost"
            size="medium"
            disabled={!showNext}
            onClick={onNavigateNext}
          />
        </Box>
      </Tooltip>
    </Flex>
  );
};

export default React.memo(ResponseNavigationControlV3);
